module.exports = __webpack_public_path__ + "media/images/app/how-it-works/sub-icon-f71392032508f798bca6b68520ac19ae.webp";